import React from "react";
import { motion } from "framer-motion";

const Footer = ({ nightMode = false }) => {
  return (
    <motion.footer
      className={`footer-suru ${nightMode ? 'footer-suru--dark' : ''}`}
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
    >
      {/* Large Background Text */}
      <div className="footer-bg-text">SURU</div>

      {/* Footer Content */}
      <div className="footer-content-grid">
        {/* Left Side - CTA */}
        <div className="footer-left">
          <h2 className="footer-cta-title">Let's talk</h2>
          <motion.button
            className="footer-cta-button"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => {
              const contactSection = document.getElementById('contact');
              if (contactSection) {
                contactSection.scrollIntoView({ behavior: 'smooth' });
              }
            }}
          >
            <span className="bullet">•</span>
            <span>GET IN TOUCH</span>
          </motion.button>
        </div>

        {/* Center - Contact Info */}
        <div className="footer-center">
          <h3 className="footer-section-title">CONTACT ME</h3>
          <a href="mailto:surmayeeu@gmail.com" className="footer-link">
            surmayeeu@gmail.com
          </a>
          <p className="footer-link">Paris, France</p>
        </div>

        {/* Right - Social Links */}
        <div className="footer-right">
          <h3 className="footer-section-title">FOLLOW ME</h3>
          <a
            href="https://www.linkedin.com/in/surmayee-umathe-4504a520a/"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-link"
          >
            LinkedIn
          </a>
          <a
            href="https://www.instagram.com/suuuruuuuuu?igsh=MWlsano4ODYxZW15eA=="
            target="_blank"
            rel="noopener noreferrer"
            className="footer-link"
          >
            Instagram
          </a>
        </div>
      </div>

      {/* Bottom Copyright */}
      <div className="footer-bottom">
        <p>© 2025 Surmayee Umathe. All rights reserved.</p>
      </div>
    </motion.footer>
  );
};

export default Footer;
